import { render } from "./BtnPlan.vue?vue&type=template&id=3a5d28ee&scoped=true&ts=true&lang=html"
import script from "./BtnPlan.vue?vue&type=script&lang=ts"
export * from "./BtnPlan.vue?vue&type=script&lang=ts"

import "./BtnPlan.vue?vue&type=style&index=0&id=3a5d28ee&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5d28ee"]])

export default __exports__